import React from 'react';
import { translate } from 'react-i18next';
import { get } from 'lodash';

import Select from 'components/atoms/Select';
import HeaderSelect from 'components/atoms/HeaderSelect';

import Icon from 'images/icons/train.svg';

const HotelSelector = ({
	t,
	hotelList,
	hotelData,
	selectedHotel,
	disabled,
	onSelect,
	selectBoxConfig,
	optionConfig,
	withIcon,
	isHeaderSelect = false,
}) => (
	<div>
		{/* eslint-disable indent */}
		{!isHeaderSelect ? (
			<Select
				options={hotelList.map(hotelKey => ({
					id: get(hotelData[hotelKey], 'id', null),
					label: get(hotelData[hotelKey], 'name', null),
					value: hotelKey,
				}))}
				selected={
					selectedHotel
						? {
								id: hotelData[selectedHotel].id,
								label: hotelData[selectedHotel].name,
								value: selectedHotel,
						  }
						: undefined
				}
				placeholder={t('selectHotel')}
				PlaceholderIcon={withIcon && Icon}
				selectBoxConfig={selectBoxConfig}
				onSelect={onSelect}
				disabled={disabled}
				optionConfig={optionConfig}
				moreWeight
			/>
		) : (
			<HeaderSelect
				options={hotelList.map(hotelKey => ({
					id: get(hotelData[hotelKey], 'id', null),
					label: get(hotelData[hotelKey], 'name', null),
					value: hotelKey,
				}))}
				selected={
					selectedHotel
						? {
								id: hotelData[selectedHotel].id,
								label: hotelData[selectedHotel].name,
								value: selectedHotel,
						  }
						: undefined
				}
				placeholder={t('selectHotel')}
				PlaceholderIcon={withIcon && Icon}
				selectBoxConfig={selectBoxConfig}
				onSelect={onSelect}
				disabled={disabled}
				optionConfig={optionConfig}
				moreWeight
			/>
		)}
		{/* eslint-enable indent */}
	</div>
);

export default translate('common')(HotelSelector);



// WEBPACK FOOTER //
// ./src/components/molecules/HotelSelector/component.js